export default (() => {
  function initMap(mapId, locations) {
    var bounds = new google.maps.LatLngBounds();
    var width = $(window).width();
    var disableControls = false;
    if (width < 600) {
      disableControls = true;
    } else {
      disableControls = false;
    }
    var map = new google.maps.Map(document.getElementById(mapId), {
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: disableControls,
      styles: [
        {
          featureType: "poi",
          stylers: [
            { visibility: "off" }
          ]
        },
        {
          featureType: "transit",
          stylers: [
            { visibility: "off" }
          ]
        }
      ]
    });
    var infoWindow = new google.maps.InfoWindow();
    for (var i = 0; i < locations.length; i++) {
      var geocoder = new google.maps.Geocoder();
      var geoOptions = {
        address: locations[i][1]
      };
      geocoder.geocode(geoOptions, createGeocodeCallback(locations[i], map, infoWindow));
    }
    function createGeocodeCallback(item, map, infoWindow) {
      return function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          var position = results[0].geometry.location;
          bounds.extend(position);
          var marker = new google.maps.Marker({
            position: position,
            map: map
          });
          if (locations.length > 1) {
            map.fitBounds(bounds);
          }
          else if (locations.length == 1) {
            map.setCenter(bounds.getCenter());
            map.setZoom(15);
          }
          google.maps.event.addListener(marker, 'click', function (event) {
            map.setCenter(marker.getPosition());
            infoWindow.setContent('<div class="p-3 pr-4 pr-lg-3">' + item[0].replace(/&#39;/g, '\"') + '</div><div class="map-close"></div>');
            infoWindow.open(map, marker);
          })
          google.maps.event.addListener(infoWindow, 'domready', function() {
            var closeBtn = $('.map-close').get();
            google.maps.event.addDomListener(closeBtn[0], 'click', function() {
              infoWindow.close();
            });
          });
        }
      };
    }
  }

  google.maps.event.addDomListener(window, 'load', function() {
    $('[data-map]').each(function() {
      var mapId = $(this).attr('data-map');
      var locations = JSON.parse(window['map_locations_' + mapId]);
      initMap(mapId, locations);
    });
  });

})()
